<template>
    <v-dialog v-model="isOpen" max-width="600px" persistent scrollable>
      <v-card class="pa-4 roundel-xl">
        <!-- TÍTULO -->
        <v-card-title class="headline text-orange-darken-2 pb-2">
          <div class="d-flex align-center">
            <v-icon left class="mr-2" color="#1D1B59">fas fa-clipboard</v-icon>
            {{ $t("views.trips.create_trip.references") }}
          </div>
          <v-btn icon @click="$emit('close')" class="ml-auto">
            <v-icon color="#1D1B59">fas fa-close</v-icon>
          </v-btn>
        </v-card-title>
  
        <v-divider class="mb-4" />
  
        <!-- CAMPOS DE TEXTO -->
        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="mb-4">
              <v-text-field
                v-model="doc_ref1Proxy"
                :label="$t('views.trips.create_trip.reference_1')"
                outlined
                class="text-field-large"
              />
            </v-col>
  
            <v-col cols="12">
              <v-text-field
                v-model="doc_ref2Proxy"
                :label="$t('views.trips.create_trip.reference_2')"
                outlined
                class="text-field-large"
              />
            </v-col>
          </v-row>
        </v-card-text>
  
        <!-- BOTONES -->
        <v-card-actions class="justify-end">
          <v-btn text color="grey" @click="$emit('close')">
            {{ $t("views.trips.create_trip.cancel") }}
          </v-btn>
          <v-btn color="orange darken-2" dark @click="saveReferences">
            {{ $t("views.trips.create_trip.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  
  <script>
  export default {
    name: "ReferenciasModal",
    props: {
      isOpen: Boolean,
      doc_ref1: String,
      doc_ref2: String,
    },
    data() {
      return {
        doc_ref1Proxy: this.doc_ref1,
        doc_ref2Proxy: this.doc_ref2,
      };
    },
    watch: {
      doc_ref1(val) {
        this.doc_ref1Proxy = val;
      },
      doc_ref2(val) {
        this.doc_ref2Proxy = val;
      }
    },
    methods: {
      saveReferences() {
        this.$emit("update:doc_ref1", this.doc_ref1Proxy);
        this.$emit("update:doc_ref2", this.doc_ref2Proxy);
        this.$emit("close");
      },
    },
  };
  </script>
  <style scoped>
  .text-field-large input {
    font-size: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  </style>
  